import script from "./UserOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOrders.vue?vue&type=script&setup=true&lang=js"

import "./UserOrders.vue?vue&type=style&index=0&id=7084e2e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7084e2e9"]])

export default __exports__